import { createSelector } from 'reselect';
import { filter } from 'ramda';
import { getFormValues } from 'redux-form';

import { filterByString } from '@topconagriculture/frontend-utils';

import { Forms } from '../../form/form.selector';
import { RootState } from '../../reducers';
import { LotMarketType } from './lotMarketTypes.types';
import { CodeElement, CodeTypeNames } from '../code/code.types';
import { getCodeListFilteredByType } from '../code/code.selector';

export const getLotMarketTypes = (state: RootState): LotMarketType[] => state.entities.lotMarketTypes;

const getLotMarketTypeClasses = (state: RootState): CodeElement[] =>
  getCodeListFilteredByType(state, { codeType: CodeTypeNames.lotMarketClassCodes });

export const getLotMarketTypesListFilteredBySearch = createSelector(
  [getLotMarketTypes, getFormValues(Forms.lotMarketTypeSearchForm)],
  (lotMarketTypesList, filterForm: any): LotMarketType[] =>
    filterForm && filterForm.search
      ? filter((groupType) => filterByString(groupType.description, filterForm.search), lotMarketTypesList)
      : lotMarketTypesList,
);

export const getLotMarketTypeDescriptionByCode = createSelector(
  [getLotMarketTypeClasses, (state: RootState, code: number) => code],
  (lotMarketTypeClasses, code): string | undefined => {
    const lotMarketTypeClass = lotMarketTypeClasses.find((el) => el.code === code);
    return lotMarketTypeClass ? lotMarketTypeClass.description1 : undefined;
  },
);
